module.exports = __webpack_public_path__ + "img/1f66b71.svg";